import { gql } from "@apollo/client";

export const DELETE_IMAGE = gql`
  mutation MyMutation($image_name: String!) {
    deleteImage(imageName: $image_name) {
      error
      message
    }
  }
`;
